import { Loader2, Plus, Trash2 } from 'lucide-react';
import type { Bank } from '../WithdrawModal.types';

type BankListStepProps = {
  banks: Bank[];
  isLoading: boolean;
  selectedBankId: string;
  onSelectBank: (bankId: string) => void;
  onDeleteBank: (bankId: string) => void;
  onAddNew: () => void;
  error: string;
};

export function BankListStep({
  banks,
  isLoading,
  selectedBankId,
  onSelectBank,
  onDeleteBank,
  onAddNew,
  error,
}: BankListStepProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-10">
        <Loader2 className="h-5 w-5 animate-spin text-[var(--dash-brand)]" />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {banks.map((b) => (
        <button
          key={b._id}
          type="button"
          onClick={() => onSelectBank(b._id)}
          className={`w-full rounded-lg border p-3 text-left transition ${
            selectedBankId === b._id
              ? 'border-[var(--dash-brand)] bg-[var(--dash-soft)]'
              : 'border-[var(--dash-line)] hover:bg-[var(--dash-soft)]/50'
          }`}
        >
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="text-sm font-semibold text-[var(--dash-ink)]">{b.bankName}</p>
              <p className="mt-0.5 text-xs text-[var(--dash-muted)]">
                {b.accountNumber} · {b.ifscCode}
              </p>
            </div>
            <span
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                onDeleteBank(b._id);
              }}
              className="rounded p-1 text-[var(--dash-muted)] hover:bg-red-50 hover:text-red-500"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </span>
          </div>
        </button>
      ))}
      {banks.length < 5 ? (
        <button
          type="button"
          onClick={onAddNew}
          className="flex w-full items-center justify-center gap-1.5 rounded-lg border border-dashed border-[var(--dash-line)] py-2.5 text-sm font-medium text-[var(--dash-muted)] hover:border-[var(--dash-brand)] hover:text-[var(--dash-brand)]"
        >
          <Plus className="h-4 w-4" /> Add bank account
        </button>
      ) : null}
      {error ? <p className="text-[11px] text-red-500">{error}</p> : null}
    </div>
  );
}
